import * as types from "../../mutation-types";

export default {
    [types.FETCH_PLANS_SUCCESS](state, data) {
        state.plans = data
    },

    [types.FETCH_PLANS_FAILURE](state) {
        state.plans = null
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/subscription/mutations.js